// extracted by mini-css-extract-plugin
export default {"container":"Anchor_container__NgeNb","loaderContainer":"Anchor_loaderContainer__o8rvt","anchor":"Anchor_anchor__AM9S5","disabled":"Anchor_disabled__9dUva"};